import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ARRIVAL_INSTRUCTIONS_MAX_LENGTH,
  JOB_DESCRIPTION_MAX_LENGTH,
} from "../../../app/constants";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { OrderFields } from "../orderTypes";
import { OrderFieldsProperties } from "./types";

type Props = {
  values: OrderFields;
  onDescriptionsChange: (
    name: string,
    value: string | null | AutocompleteType,
  ) => void;
  handleChangeCallback: (
    name: OrderFieldsProperties,
    newValue:
      | AutocompleteType[]
      | AutocompleteType
      | Date
      | null
      | number
      | string
      | boolean,
  ) => void;
};

const Descriptions = ({
  values,
  onDescriptionsChange,
  handleChangeCallback,
}: Props) => {
  const { t } = useTranslation("order");

  return (
    <>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("jobDescriptionFI")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <CommonTextField
          fullWidth
          multiline
          minRows={4}
          value={
            values.description ||
            values.workLocation.info[values.orderTemplate.workTitleId]?.fi
          }
          onChange={(e) => {
            handleChangeCallback("description", e.target.value);
          }}
          inputProps={{ maxLength: JOB_DESCRIPTION_MAX_LENGTH }}
        />
      </Grid>
      <Grid
        container
        item
        xs={4}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">
          {t("arrivalInstructionsFI")}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <CommonTextField
          fullWidth
          size="small"
          name="descriptionForTalent"
          value={values.workLocation.descriptionForTalent}
          onChange={(e) => onDescriptionsChange(e.target.name, e.target.value)}
          helperText={t("arrivalInstructionsHelper")}
          inputProps={{ maxLength: ARRIVAL_INSTRUCTIONS_MAX_LENGTH }}
          multiline
          minRows={1}
        />
      </Grid>
      <Grid container item xs={4} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("jobDescriptionEN")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <CommonTextField
          fullWidth
          multiline
          minRows={4}
          value={
            values.descriptionEn ||
            values.workLocation.info[values.orderTemplate.workTitleId]?.en
          }
          onChange={(e) =>
            handleChangeCallback("descriptionEn", e.target.value)
          }
          inputProps={{ maxLength: JOB_DESCRIPTION_MAX_LENGTH }}
        />
      </Grid>
      <Grid
        container
        item
        xs={4}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">
          {t("arrivalInstructionsEN")}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <CommonTextField
          fullWidth
          size="small"
          name="descriptionForTalentEng"
          value={values.workLocation.descriptionForTalentEng}
          onChange={(e) => onDescriptionsChange(e.target.name, e.target.value)}
          helperText={t("arrivalInstructionsHelper")}
          inputProps={{ maxLength: ARRIVAL_INSTRUCTIONS_MAX_LENGTH }}
          multiline
          minRows={1}
        />
      </Grid>
    </>
  );
};

export default Descriptions;
